/**
 * Cloudflare Worker API & WebSocket 配置
 *
 * 部署后请将 CLOUDFLARE_HOST 改为你的 Worker 域名
 */
// 开发环境走本地 proxy，生产环境改成你的 Worker 域名
const IS_DEV = window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.6';
const CLOUDFLARE_HOST = 'https://sambot.deepbox.site';
export const API_BASE = IS_DEV ? '/api' : `${CLOUDFLARE_HOST}/api`;
export const WS_URL = 'wss://sambot.deepbox.site/api/ws';

/**
 * axios 实例，预配置 baseURL，方便直接使用
 */
import axios from 'axios';

export const http = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// 请求拦截器：自动携带 token
http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});